import { useEffect, useState } from "react";
import { Col, Row, Select } from "antd";
import BRAKE from "../../../../assets/images/icons/brake.svg";
import { UNITS } from "../../../Common/Constants";
import { TEST_RIDE_CUMULATIVE } from "../../../Common/Grafana/Constants";
import panelList from "../panelList.json";
import CardCollapse from "../../../Common/CardCollapse";
import ChartFilter from "../../../Common/ChartFilter";
import PanelsRow from "../../../Common/Grafana/PanelsRow";

const BrakeAnalytics = ({
  tripSummary,
  summaryList,
  baseUrl,
  baseFilterObject,
  data
}) => {
  const summaryCount = summaryList?.length;
  const [chartType, setChartType] = useState({
    histogram: true,
    boxPlot: false,
  });
  const [brakeList, setBrakeList] = useState([]);

  useEffect(() => {
    setBrakeList([panelList?.brake[0]]);
  }, []);

  const updateChartType = (name, value) => {
    setChartType((prev) => ({ ...prev, [name]: value }));
  };

  const onSelectBattery = (selectedValues) => {
    const selectedObjects = panelList?.brake?.filter((item) =>
      selectedValues.includes(item.var_name)
    );
    setBrakeList(selectedObjects);
  };

  const subContent = (
    <>
      <Row gutter={[16, 16]} justify="space-between" className="mt05">
        <Col xs={24} sm={14} md={14} lg={14} xl={14}>
          <Select
            value={brakeList?.map((item) => item.var_name)}
            mode="tags"
            style={{ width: "100%" }}
            onChange={onSelectBattery}
            options={panelList?.brake?.map((i) => ({
              label: i.title,
              value: i.var_name,
            }))}
          />
        </Col>
        <Col
          xs={summaryCount >= 2 ? 6 : 6}
          sm={summaryCount >= 2 ? 6 : 6}
          md={summaryCount >= 2 ? 6 : 3}
          lg={summaryCount >= 2 ? 6 : 3}
          xl={summaryCount >= 2 ? 6 : 3}
        >
          <ChartFilter
            updateChartType={updateChartType}
            chartType={chartType}
            chartToHide={"timeSeries"}
          />
        </Col>
      </Row>
      <div className="grey-box mt1">
        <Row gutter={[16, 16]} justify="center">
          <Col
            xs={24}
            sm={12}
            md={summaryCount >= 2 ? 24 : 5}
            lg={summaryCount >= 2 ? 12 : 5}
            xl={summaryCount >= 2 ? 12 : 5}
          >
            Total Brakes:
            <span className="ml025 bold">{tripSummary?.totalBrakes}</span>
          </Col>
          <Col
            xs={24}
            sm={12}
            md={summaryCount >= 2 ? 24 : 5}
            lg={summaryCount >= 2 ? 12 : 5}
            xl={summaryCount >= 2 ? 12 : 5}
          >
            Brakes/km:
            <span className="ml025 bold">{tripSummary?.numberOfBrakesPerKm || 0}</span>
          </Col>
          <Col
            xs={24}
            sm={12}
            md={summaryCount >= 2 ? 24 : 5}
            lg={summaryCount >= 2 ? 12 : 5}
            xl={summaryCount >= 2 ? 12 : 5}
          >
            Avg Distance/Brake:
            <span className="ml025 bold">
              {tripSummary?.averageBrakingDistance || 0}
            </span>
            <span className="ml025">{UNITS.METER}</span>
          </Col>
          <Col
            xs={24}
            sm={12}
            md={summaryCount >= 2 ? 24 : 5}
            lg={summaryCount >= 2 ? 12 : 5}
            xl={summaryCount >= 2 ? 12 : 5}
          >
            Avg Duration/Brake:
            <span className="ml025 bold">
              {tripSummary?.averageBrakingDuration || 0}
            </span>
            <span className="ml025">{UNITS.SECONDS}</span>
          </Col>
        </Row>
      </div>
    </>
  );

  return (
    <CardCollapse
      cardClassName="ride-statistic-analytics-card"
      icon={BRAKE}
      title={"Brake Analytics"}
      subContent={subContent}
    >
      <Row className="pd0">
        {brakeList?.map((panel, index) => (
          <Col key={index} span={24}>
            <PanelsRow
              title={panel.title}
              url={baseUrl}
              histogramPanel={
                chartType?.histogram &&
                TEST_RIDE_CUMULATIVE.PANEL_ID[panel.var_name]["histogram"]
              }
              boxPlotPanel={
                chartType?.boxPlot &&
                TEST_RIDE_CUMULATIVE.PANEL_ID[panel.var_name]["boxPlot"]
              }
              baseFilterObject={baseFilterObject}
              variableKeys={TEST_RIDE_CUMULATIVE.BASE_VARIABLES}
              data={data}
            />
          </Col>
        ))}
      </Row>
    </CardCollapse>
  );
};

export default BrakeAnalytics;
